export enum RoleNameEnum {
  SUPER_ADMIN = 'super admin',
  ADMIN = 'admin',
  FINANCIAL_ADMIN = 'financial admin',
  HR_ADMIN = 'hr admin',
  MARKETING_ADMIN = 'marketing admin',
  CLIENT = 'client',
}

export enum McpRoleTypeEnum {
  PREDEFINED = 'predefined',
  CUSTOM = 'custom',
}

export enum McpActionEnum {
  READ = 'read',
  WRITE = 'write',
}
